import { toast } from 'sonner';

import type { SubmitHandler, UseFormSetError } from 'react-hook-form';

import { useMutation } from '@tanstack/react-query';
import type { IErrorVM } from '~/types';
import { contactApi, type IContactUsRequest } from '~/requests/contactApi';

import type { TContactUsSchema } from './interface';
interface IUseSubmitParams {
  setError: UseFormSetError<TContactUsSchema>;
}

interface IUseSubmitReturnProps {
  isPending: boolean;
  isSuccess: boolean;
  submit: SubmitHandler<TContactUsSchema>;
}

export function useSubmit({
  setError,
}: IUseSubmitParams): IUseSubmitReturnProps {
  const { mutate, isPending, isSuccess } = useMutation<
    void,
    IErrorVM,
    IContactUsRequest
  >({
    mutationFn: async (payload) => {
      contactApi.contactUs(payload);
    },
    onSuccess: () => {
      toast.success('Message sent successfully');
    },
    onError: (error) => {
      console.error('Submission error:', error);

      setError('email', {
        type: 'manual',
        message: 'Something went wrong. Please try again.',
      });
    },
  });

  const submit: SubmitHandler<TContactUsSchema> = (data) => {
    mutate(data);
  };

  return {
    submit,
    isPending,
    isSuccess,
  };
}
